module.exports = __webpack_public_path__ + "a85297cb1e8803d80588b9fdce475898.pdf";